import { css } from 'styled-components';

export const container = css`
  background-color: var(--neutral-black-10);
  padding: 64px 0;
`;

export const box = css`
  background-color: white;
  max-width: 500px;
  border-radius: 10px;
  margin: 0 auto;
  padding: 40px 50px;
  text-align: center;
  color: var(--neutral-black-70);
  line-height: 1.75;
`;

export const message = css`
  margin: 24px 0 32px;
`;

export const header = css`
  font-size: 20px;
  font-weight: bold;
  margin-top: 0;
`;
